"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var GraphQLErrorFunctions_1 = require("../../error/functions/GraphQLErrorFunctions");
var VizPortalTypes_1 = require("../../utils/VizPortalTypes");
var SelectionColumn_1 = require("../datagrid/sharedColumns/SelectionColumn");
var ExplorerStyledDisplayGrid_1 = require("../sharedDisplayGrid/ExplorerStyledDisplayGrid");
var TablesDisplayGrid_1 = require("../sharedDisplayGrid/TablesDisplayGrid");
function DatabaseTablesDisplayGrid(props) {
    var columnFactoryParams = VizPortalTypes_1.addNoopActionCellWrapper(props);
    var cols = [
        SelectionColumn_1.createSelectionColumn()
    ].concat(TablesDisplayGrid_1.columns.map(function (columnFactory) { return columnFactory(columnFactoryParams); }).filter(function (column) { return column.name !== 'database'; }));
    return (React.createElement(ExplorerStyledDisplayGrid_1.ExplorerStyledDisplayGrid, { columns: cols, rowStore: props.rowStore, selectedKeys: props.selectedKeys, updateSelectionForKey: props.updateSelectionForKey, rowCount: props.rowCount, renderErrors: GraphQLErrorFunctions_1.reportGraphQLErrors, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }));
}
exports.DatabaseTablesDisplayGrid = DatabaseTablesDisplayGrid;
//# sourceMappingURL=DatabaseTablesDisplayGrid.js.map